/** Idle window (ms) before adapters call `pause('idle')`; also max credit on idle clock-jump. */
export const DEFAULT_IDLE_TIMEOUT_MS = 60_000;

/** Cap on emitted `duration_ms` / `duration_seconds` (30 min product metric). */
export const DEFAULT_MAX_DURATION_MS = 1_800_000;

/**
 * If a live segment exceeds this when pausing for idle/hidden, treat as sleep/throttle
 * clock-jump: increment `clock_jump_count`; credit ≤ idle timeout (idle) or 0 (hidden).
 */
export const DEFAULT_CLOCK_JUMP_IDLE_THRESHOLD_MS = 5 * 60 * 1000;

/** Max hops kept in `surface_path` (e.g. `search>doc>search`); oldest dropped. */
export const MAX_SURFACE_PATH_SEGMENTS = 8;
